/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RadarLedgerSnapshotResponse } from './RadarLedgerSnapshotResponse';
import type { RadarPortfolioSnapshotResponse } from './RadarPortfolioSnapshotResponse';
import type { RadarRuleConfigResponse } from './RadarRuleConfigResponse';
import type { RadarSignalSnapshotResponse } from './RadarSignalSnapshotResponse';
import type { RadarStrategyVersionOptionResponse } from './RadarStrategyVersionOptionResponse';
export type RadarWorkspaceResponse = {
    strategy_version: RadarStrategyVersionOptionResponse;
    portfolio: RadarPortfolioSnapshotResponse;
    ledger_snapshot: RadarLedgerSnapshotResponse;
    rule_config: RadarRuleConfigResponse;
    scan_asof: string;
    signals: Array<RadarSignalSnapshotResponse>;
    market_data_status: RadarWorkspaceResponse.market_data_status;
    cache_status: RadarWorkspaceResponse.cache_status;
    warnings?: Array<string>;
};
export namespace RadarWorkspaceResponse {
    export enum market_data_status {
        OK = 'ok',
        DEGRADED = 'degraded',
        UNAVAILABLE = 'unavailable',
    }
    export enum cache_status {
        HIT = 'hit',
        MISS = 'miss',
        MIXED = 'mixed',
    }
}

